import { render, staticRenderFns } from "./linkItem.vue?vue&type=template&id=7c71a52b&scoped=true&"
import script from "./linkItem.vue?vue&type=script&lang=js&"
export * from "./linkItem.vue?vue&type=script&lang=js&"
import style0 from "./linkItem.vue?vue&type=style&index=0&id=7c71a52b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71a52b",
  null
  
)

export default component.exports